export const NOTIFICATION_ALL_TYPE = 'notification-all-type';
export const NOTIFICATION_INVITATION_TYPE = 'notification-invitation-type';
export const NOTIFICATION_INVITATION_TYPE_API_REF = 'invitation';
export const NOTIFICATION_MIDTRANS_PAYMENT_TYPE_API_REF = 'midtrans payment notification';
export const NOTIFICATION_COMPANY_BILL_TYPE_API_REF = 'company_bill';
